module.exports = __webpack_public_path__ + "static/img/智能体协同作业.09da649b.png";